import { post, get } from './http.api';
import {
  Parameters,
  LocationTableRow,
  LocationTableData,
  LocationResponse,
  LocationApiData,
} from '@app/models/locations/location-response.model';
import { LocationRequest } from '@app/models/locations/location-request.model';
export const getLocationTableData = async (parameters: Parameters): Promise<LocationTableData> => {
  try {
    const { data, status } = await get<any>('locations', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const locations: LocationTableRow[] = data.data.map((locationData: any) => ({
      id: locationData.id,
      code: locationData.code,
      name: locationData.name,
    }));

    return {
      data: locations,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
      status_options: data.status_options,
    };
  } catch (error: any) {
    console.error('Error fetching Locations:', error);
    throw error;
  }
};

export const getAllLocations = async (): Promise<LocationResponse> => {
  try {
    const { data, status } = await get<LocationResponse>(`locations`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getLocactionById = async (id: number): Promise<LocationResponse> => {
  try {
    const { data, status } = await get<LocationResponse>(`locations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const storeLocation = async (locationData: LocationRequest) => {
  try {
    const response = await post<any>('locations/create', locationData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createLocation = async (): Promise<LocationApiData> => {
  try {
    const { data, status } = await get<LocationApiData>(`locations/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showLocation = async (id: number) => {
  try {
    const { data, status } = await get<LocationApiData>(`locations/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editLocation = async (id: number) => {
  try {
    const { data, status } = await get<LocationApiData>(`locations/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateLocation = async (id: number, Updatecategory: LocationRequest) => {
  try {
    const { data, status } = await post<LocationRequest>(`locations/${id}/edit`, Updatecategory, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
